import * as t from 'utils/fieldConstants';
import { FieldOption } from 'modules/queryBuilder/legacyQueryBuilder/types';
import { CAMPAIGN_LABEL_TYPE_FIELDS } from 'utils/fieldTypes';

export const fields = t;

// Matches ReservedCustomFields in scala codebase.
export const RESERVED_CUSTOM_FIELDS = [t.CREATION_DATE, t.EMAIL, t.CAMPAIGN, t.TEMPLATE_ID];

// Custom display names for specific field types.
export const customFieldDisplayNames = {
  [t.CAMPAIGN]: 'Campaign',
  [t.CAMPAIGN_LABEL]: 'Campaign label',
  [t.CONTENT_ID]: 'Content ID',
  [t.CREATION_DATE]: 'Creation date',
  [t.LIST_MEMBERSHIP]: 'List membership',
  [t.MESSAGE_CHANNEL]: 'Message channel',
  [t.MESSAGE_TYPE]: 'Message type',
  [t.PHONE_COUNTRY]: 'Phone country',
  [t.PHONE_TYPE]: 'Phone type',
  [t.PHONE_NUMBER]: 'Phone number',
  [t.PROFILE_UPDATED_DATE]: 'Profile updated date',
  [t.RECURRING_CAMPAIGN]: 'Recurring campaign',
  [t.SIGNUP_DATE]: 'Signup date',
  [t.SIGNUP_SOURCE]: 'Signup source',
  [t.TEMPLATE_ID]: 'Template ID',
  [t.UNSUBSCRIBED_CHANNELS]: 'Unsubscribed channels',
  [t.UNSUBSCRIBED_MESSAGE_TYPES]: 'Unsubscribed message types',
  [t.USER_LIST]: 'User list',
};

export const getFieldDisplayName = (field: keyof typeof customFieldDisplayNames) =>
  customFieldDisplayNames[field] || field;

export const CAMPAIGN_LABEL_FIELD = {
  value: t.CAMPAIGN_LABEL,
  type: CAMPAIGN_LABEL_TYPE_FIELDS[0],
  text: getFieldDisplayName(t.CAMPAIGN_LABEL),
};

export const getFilteredFields = (
  fieldOptions: FieldOption[],
  propertyMap: { type?: string; value?: string } = {},
) => {
  return fieldOptions?.filter((option) =>
    propertyMap.type ? propertyMap.type !== option.type : propertyMap.value !== option.value,
  );
};

export default fields;
